<template>
    <v-select
        v-model="setup.selectedItems"
        :items="setup.items"
        :label="setup.label"
        :item-text="setup.text"
        :item-value="setup.value"
        :prepend-icon="setup.icon"
        :rules="(setup.rule) ? setup.rule : undefined"
        :required="setup.required"
        :readonly="setup.readonly"
        :multiple="setup.multiple"
        :filled="setup.filled"
        dense
        :clearable="setup.clearable"
    >
        <template v-slot:prepend-item v-if="setup.multiple">
            <v-list-item
                ripple
                @click="toggleSelectItem(setup)"
            >
                <v-list-item-content>
                    <v-list-item-title>{{ selectAction(setup) }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>

        <template
            slot="selection"
            slot-scope="{ item, index }"
        >
            <span v-if="index === 0">{{ item[setup.text] }}</span>
            <span
                v-if="index === 1"
                class="grey--text caption"
            >&nbsp;(+{{ setup.selectedItems.length - 1 }} outros)</span>
        </template>
    </v-select>
</template>

<script>
export default {
    name: 'input-select',
    props: ['setup'],
    data () { return {} },
    methods: {
        selectAction: function (vm) {
            return (vm.selectedItems.length !== vm.items.length) ? 'Marcar tudo' : 'Desmarcar tudo'
        },
        toggleSelectItem (select) {
            this.$nextTick(() => {
                if (select.selectedItems.length === select.items.length) {
                    select.selectedItems = []
                } else {
                    select.items.forEach((item) => {
                        if (select.selectedItems.indexOf(item[this.setup.value]) === -1) {
                            select.selectedItems.push(item[this.setup.value])
                        }
                    })
                }
            })
        }
    }
}
</script>
